import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    transaction: {
        id: null,
        receipt_number: null,
        discounts: [],
        forecourt_attendant: {
            id: null,
        },
        outlet: {
            company_details: {},
        },
        line_items: [
            {
                item_type: null,
                applied_discounts: [],
            },
        ],
    },
};

const getters = {
    pgsql_transaction: state => state.transaction,

    receiptType: state => state.transaction.receipt_type,

    isSale: (state, getters) => getters.receiptType === 'SALE',

    isVoid: (state, getters) => getters.receiptType === 'VOID',

    isRefund: (state, getters) => getters.receiptType === 'REFUND',

    outlet: state => state.transaction.outlet,

    receipt: state => {
        return {
            receipt_number: state.transaction.id,
            sequence_number: state.transaction.receipt_number,
        };
    },

    discountLineItems: state => {
        let discountLineItems = state.transaction.line_items.filter(item => {
            return item.applied_discounts.length;
        });

        if (discountLineItems.length) {
            let di = state.transaction.discounts;

            discountLineItems.map(item => {
                item.applied_discounts.map(appliedDiscount => {
                    let discount = di.find(
                        d => d.id === appliedDiscount.discount_id,
                    );

                    if (discount) {
                        appliedDiscount.discount = discount;
                    }
                });
            });
        }

        discountLineItems.sort((a, b) => {
            if (a.item_type > b.item_type) {
                return -1;
            }

            return 0;
        });

        return discountLineItems;
    },

    multipleDiscountLineItems: state => {
        let discountLineItems = state.transaction.line_items.filter(item => {
            return item.applied_discounts.length > 1;
        });

        return discountLineItems.length;
    },

    groupDiscounts: (state, getters) => {
        let discounts = state.transaction.discounts;

        let groupDiscounts = _.groupBy(discounts, 'promotion_id');

        let mapGroupDiscounts = [];

        _.map(groupDiscounts, discounts => {
            let lineItems = [];
            let promotionId = discounts[0].promotion_id;
            let discountName = discounts[0].name;
            let discountSource = discounts[0].discount_source;

            let discountQuantity = discounts
                .map(discount => {
                    return parseFloat(discount.quantity);
                })
                .reduce((a, b) => a + b, 0);

            mapGroupDiscounts.push({
                discountName,
                discountQuantity,
                promotionId,
                lineItems,
                discountSource,
            });
        });

        mapGroupDiscounts.map(mapGroupDiscount => {
            let discountLineItems = getters.discountLineItems;

            discountLineItems.map(lineItem => {
                lineItem.applied_discounts.map(appliedDiscount => {
                    if (
                        appliedDiscount.discount.promotion_id ===
                        mapGroupDiscount.promotionId
                    ) {
                        mapGroupDiscount.lineItems.push(lineItem);
                    }
                });
            });

            let groupLineItems = _.groupBy(
                mapGroupDiscount.lineItems,
                'product_id',
            );

            let mapGroupLineItems = [];

            _.map(groupLineItems, lineItems => {
                let productName = lineItems[0].name;
                let unitPrice = lineItems[0].unit_price;
                let itemType = lineItems[0].item_type;
                let fuelDetails = lineItems[0].fuel_details;

                let quantity = lineItems
                    .map(lineItem => {
                        return parseFloat(lineItem.quantity);
                    })
                    .reduce((a, b) => a + b, 0);

                let netAmount = lineItems
                    .map(lineItem => {
                        return parseFloat(lineItem.net_amount);
                    })
                    .reduce((a, b) => a + b, 0);

                let totalDiscount = lineItems[0].applied_discounts
                    .map(appliedDiscount => {
                        return parseFloat(appliedDiscount.applied_amount);
                    })
                    .reduce((a, b) => a + b, 0);

                let totalAmount = lineItems
                    .map(lineItem => {
                        return parseFloat(lineItem.total_amount);
                    })
                    .reduce((a, b) => a + b, 0);

                let amount = lineItems
                    .map(lineItem => {
                        return parseFloat(lineItem.amount);
                    })
                    .reduce((a, b) => a + b, 0);

                mapGroupLineItems.push({
                    productName,
                    unitPrice,
                    quantity,
                    netAmount,
                    totalDiscount,
                    totalAmount,
                    amount,
                    itemType,
                    fuelDetails,
                });
            });

            mapGroupDiscount.groupLineItems = mapGroupLineItems;
        });

        return mapGroupDiscounts;
    },

    fuels: state => {
        return state.transaction.line_items.filter(lineItem => {
            return (
                lineItem.item_type === 'fuel' &&
                !lineItem.applied_discounts.length
            );
        });
    },

    products: state => {
        return state.transaction.line_items.filter(lineItem => {
            return (
                lineItem.item_type === 'cstore' &&
                !lineItem.cancelled &&
                (!lineItem.applied_discounts.length ||
                    state.transaction.receipt_type === 'REFUND')
            );
        });
    },

    cancelProducts: state => {
        return state.transaction.line_items.filter(lineItem => {
            return lineItem.item_type === 'cstore' && lineItem.cancelled;
        });
    },

    totalSaving: state => {
        return Math.abs(
            state.transaction.discounts
                .map(d => {
                    return parseFloat(d.applied_amount);
                })
                .reduce((a, b) => a + b, 0),
        ).toFixed(2);
    },

    change: state => {
        let change = 0;

        let cash = state.transaction.payments.find(p => p.type === 0);

        if (cash) {
            change = cash.change ? cash.change : 0;
        }

        return change.toFixed(2);
    },

    paymentName: state => {
        return state.transaction.payments.map(p => p.name.toLowerCase());
    },

    overrun: state => {
        let overrunFuel = state.transaction.line_items.find(lineItem => {
            return (
                lineItem.item_type === 'fuel' &&
                lineItem.fuel_details &&
                lineItem.fuel_details.overrun &&
                lineItem.fuel_details.overrun.amount > 0
            );
        });

        return overrunFuel ? overrunFuel.fuel_details.overrun.amount : 0;
    },

    approvalCode: state => {
        let edc = state.transaction.payments.find(p => p.source === 'edc');

        if (edc) {
            return edc.card.approval_code;
        }

        let shellApp = state.transaction.payments.find(
            p => p.source === 'shell_app',
        );

        if (shellApp) {
            return shellApp.details.approvalCode;
        }

        let tngRfid = state.transaction.payments.find(
            p => p.source === 'tng_rfid',
        );

        if (tngRfid) {
            return tngRfid.details.approvalCode;
        }

        return null;
    },

    stan: state => {
        let shellApp = state.transaction.payments.find(
            p => p.source === 'shell_app',
        );

        if (shellApp) {
            return shellApp.details.stan;
        }

        return null;
    },

    referenceNo: state => {
        let eps = state.transaction.payments.find(
            p => p.source === 'eps_invenco',
        );

        if (eps) {
            return eps.details.reference_no;
        }

        let ewallet = state.transaction.payments.find(
            p => p.source === 'ewallet',
        );

        if (ewallet) {
            return ewallet.ewallet.reference_no;
        }

        let subsidy = state.transaction.payments.find(
            p => p.source === 'subsidy',
        );

        if (subsidy) {
            return subsidy.subsidy.reference_no;
        }

        return null;
    },

    ghlPaymentReferenceNo: state => {
        let ghl = state.transaction.payments.find(p => p.source === 'ghl');

        if (ghl) {
            return ghl.details.OriginalRetTxnRef
                ? ghl.details.OriginalRetTxnRef
                : ghl.details.RetTxnRef;
        }

        return null;
    },

    ghlMerchantId: state => {
        let ghl = state.transaction.payments.find(p => p.source === 'ghl');

        if (ghl) {
            return ghl.details.MerchantID ? ghl.details.MerchantID : null;
        }

        return null;
    },

    ghlTerminalId: state => {
        let ghl = state.transaction.payments.find(p => p.source === 'ghl');

        if (ghl) {
            return ghl.details.TerminalID ? ghl.details.TerminalID : null;
        }

        return null;
    },

    ghlRefundReferenceNo: state => {
        let ghl = state.transaction.payments.find(p => p.source === 'ghl');

        if (ghl) {
            return ghl.details.OriginalRetTxnRef == null
                ? null
                : ghl.details.RetTxnRef;
        }
    },

    loyaltyDetails: state => {
        return state.transaction.loyalty;
    },

    eftDetails: state => {
        return state.transaction.payments.find(p => p.source === 'eps_invenco');
    },

    groupTaxes: (state, getters) => {
        let taxes = state.transaction.taxes;

        let groupTaxes = _.groupBy(taxes, 'tax_id');

        let mapGroupTaxes = [];

        _.map(groupTaxes, taxes => {
            let taxId = taxes[0].tax_id;
            let taxName = taxes[0].name;

            let taxTotal = taxes
                .map(taxes => {
                    return parseFloat(taxes.applied_amount);
                })
                .reduce((a, b) => a + b, 0);

            mapGroupTaxes.push({
                taxId,
                taxName,
                taxTotal,
            });
        });

        return mapGroupTaxes;
    },

    capillaryDiscounts: state => {
        let capillaryDiscounts = state.transaction.discounts.filter(
            discount => {
                return discount.discount_source === 'SHELL_CAPILLARY';
            },
        );

        let groupCapillaryDiscounts = _.groupBy(capillaryDiscounts, 'name');

        let mapGroupCapillaryDiscounts = [];

        _.map(groupCapillaryDiscounts, discounts => {
            let discountName = discounts[0].name;

            let discountAppliedAmount = discounts
                .map(discount => {
                    return parseFloat(discount.applied_amount);
                })
                .reduce((a, b) => a + b, 0);

            mapGroupCapillaryDiscounts.push({
                discountName,
                discountAppliedAmount,
            });
        });

        return mapGroupCapillaryDiscounts;
    },
};

const mutations = {
    setTransaction(state, data) {
        state.transaction = data;
    },
};

const actions = {
    async getTransactionPostgres({ dispatch, commit }, receiptNumber) {
        startLoading(dispatch, 'fetch-transaction');

        let url = Laroute.route(
            'franchise.report.transaction.getTransactionReceiptPostgres',
            { receiptNumber },
        );

        try {
            const { data } = await axios.get(url);
            endLoading(dispatch, 'fetch-transaction');

            commit('setTransaction', data);

            return data;
        } catch (e) {
            endLoading(dispatch, 'fetch-transaction');
            throw e;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/transaction-postgres.js